export const TESTING = false;

export const FACEBOOK_PIXEL_ID = '1081452435206495';
export const FACEBOOK_APP_ID = '831395673663755';
export const GOOGLE_TRACKING_ID = 'UA-56755036-1';
export const APPS_FLYER_SDK_KEY = 'JpLuWySSwLtuaQi7aXgo9F';
export const APP_STORE_APP_ID = 'id960043499';
